import { render } from "./template.2642.vue?vue&type=template&id=0c978e9b"
import script from "./template.2642.vue?vue&type=script&lang=js"
export * from "./template.2642.vue?vue&type=script&lang=js"

import "./template.2642.vue?vue&type=style&index=0&id=0c978e9b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__